import { render, staticRenderFns } from "./ModalFecha.vue?vue&type=template&id=5b045190&"
import script from "./ModalFecha.vue?vue&type=script&lang=js&"
export * from "./ModalFecha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports